import { useCallback } from 'react';
import { AboutUsService } from 'api/aboutUs/service';

export const useAboutUs = () => {
    const onGetAllAboutUs = useCallback(async () => {
        try {
            const response = await AboutUsService.getInstance().findAll();
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []); // Оборачиваем в useCallback

    const onGetOneAboutUs = useCallback(async (id: number) => {
        try {
            const response = await AboutUsService.getInstance().findOne(id);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []); // Оборачиваем в useCallback

    return { onGetAllAboutUs, onGetOneAboutUs };
};
